import { Component, Input, OnChanges } from '@angular/core';
import { NbDialogService } from '@nebular/theme';
import { EnergySettingsDialogComponent } from '../energy-settings-dialog/energy-settings-dialog.component';
import { CONSUMPTION_TYPE_FILTER_OPTIONS } from '../energy-settings-dialog/consumption-type-filter/consumption-type-filter.component';
import { Observable, map } from 'rxjs';
import { ChartFiltersService } from '../../../@core/utils';
import { TranslateModule } from '@ngx-translate/core';
import { AsyncPipe } from '@angular/common';

@Component({
  selector: 'app-consumption-type-button',
  templateUrl: './consumption-type-button.component.html',
  styleUrls: ['./consumption-type-button.component.scss'],
  standalone: true,
  imports: [
    TranslateModule,
    AsyncPipe,
  ],
})
export class ConsumptionTypeButtonComponent implements OnChanges {

  @Input() public energyOrCarbon: 'energy' | 'carbon';

  public options = CONSUMPTION_TYPE_FILTER_OPTIONS;

  public consumptionTypeLabel$: Observable<string>;

  constructor(
    private dialogService: NbDialogService,
    private chartFiltersService: ChartFiltersService,
  ) { }

  ngOnChanges(): void {
    this.consumptionTypeLabel$ = (
      this.energyOrCarbon === 'energy'
      ? this.chartFiltersService.filter$('energyConsumptionType', false)
      : this.chartFiltersService.filter$('carbonConsumptionType', false)
    ).pipe(
      map((consumptionType) => {
        return this.options.find((option) => option.value === consumptionType)?.label;
      }),
    );
  }

  public openEnergySettingsDialog(event: Event): void {
    event.stopPropagation();
    this.dialogService.open(
      EnergySettingsDialogComponent,
      {
        autoFocus: false,
        context: {
          defaultSelectedTab: 'consumptionType',
        },
      },
    );
  }

}
